import { render, staticRenderFns } from "./VirtualShopTagStatus.vue?vue&type=template&id=bb9691fc&scoped=true"
import script from "./VirtualShopTagStatus.vue?vue&type=script&lang=ts"
export * from "./VirtualShopTagStatus.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopTagStatus.vue?vue&type=style&index=0&id=bb9691fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9691fc",
  null
  
)

export default component.exports